import React from 'react';

function ThemeToggle({ theme, onToggle }) {
  return (
    <button 
      className="theme-toggle"
      onClick={onToggle}
      title={theme === 'dark' ? 'מעבר למצב יום' : 'מעבר למצב לילה'}
    >
      {theme === 'dark' ? '☀️' : '🌙'}
    </button>
  );
}

export default ThemeToggle;
